import LogsSettings from '@/admin/pages/settings/logs-settings';
import { logsQuery } from '@/admin/queries/logs';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/logs')({
	loader: ({ context }) => context.queryClient.ensureQueryData(logsQuery()),
	component: LogsSettings,
});
